import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import DatePicker from 'react-datepicker2';

export default class TrialbalanceReport extends Base {
	constructor(props) {
		super(props);
		this.state = {
			data: null,
            loading: true,
            fromDate: null,
            toDate: null,
            accountId: null,
            type: 2,
            configName: 'trialbalance_report'
		}
	}
    componentDidMount() {
        this.getData();
    }
    getData() {
        this.httpPost("api/v1/report/trial")
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    getDefaultConfig() {
        if (this.state.type === 2) {
            return {
                name: this.state.configName,
                fields: [
                    { field: "name", caption: "نام حساب", show: true },
                    { field: "code", caption: "کدحساب", show: true },
                    { field: "fullCode", caption: "کدینگ کامل", show: true },
                    { field: "bed", caption: "مانده بدهکار", show: true },
                    { field: "bes", caption: "مانده بستانکار", show: true },
                ]
            }
        }
        if (this.state.type === 4) {
            return {
                name: this.state.configName,
                fields: [
                    { field: "name", caption: "نام حساب", show: true },
                    { field: "code", caption: "کدحساب", show: true },
                    { field: "fullCode", caption: "کدینگ کامل", show: true },
                    { field: "sumBed", caption: "گردش بدهکار", show: true },
                    { field: "sumBes", caption: "گردش بستانکار", show: true },
                    { field: "bed", caption: "مانده بدهکار", show: true },
                    { field: "bes", caption: "مانده بستانکار", show: true },
                ]
            }
        }
        return {
            name: this.state.configName,
            fields: [
                { field: "name", caption: "نام حساب", show: true },
                { field: "code", caption: "کدحساب", show: true },
                { field: "fullCode", caption: "کدینگ کامل", show: true },
                { field: "bedInit", caption: "مانده بدهکار ابتدای دوره", show: true },
                { field: "besInit", caption: "مانده بستانکار ابتدای دوره", show: true },
                { field: "sumBed", caption: "گردش بدهکار", show: true },
                { field: "sumBes", caption: "گردش بستانکار", show: true },
                { field: "bed", caption: "مانده بدهکار", show: true },
                { field: "bes", caption: "مانده بستانکار", show: true },
            ]
        }
    }
    getColumns() {
        //ذخیره کانفیگ نداره
        //var config = this.getGridConfig();
        var config = this.getDefaultConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'date' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'name' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'code' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'fullCode' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'bedInit' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.bedInit) } });
            if (f.field == 'besInit' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.besInit) } });
            if (f.field == 'sumBed' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.sumBed) } });
            if (f.field == 'sumBes' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.sumBes) } });
            if (f.field == 'bed' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.bed) } });
            if (f.field == 'bes' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.bes) } });
        });
        return t;
    }
	renderForm() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="panel panel-info">
                            <div className="panel-body">
                                <div className="col-sm-3">
                                    ترازحسابها(تراز آزمایشی)
                                </div>
                                <div className="col-sm-6 text-center" style={{ "display": "flex", "place-content": "center" }}>
                                    <select className="form-control" defaultValue={this.state.type} onChange={e => this.setState({ type: parseInt(e.target.value) })}>
                                        <option value="2">دو ستونه</option>
                                        <option value="4">چهار ستونه</option>
                                        <option value="6">شش ستونه</option>
                                    </select>
                                    از
                                    <DatePicker
                                        inputReadOnly={true}
                                        className="range-from-example text-center mr-l-5 mr-r-5"
                                        style={{ border: "solid 1px #ccc" }}
                                        placeholder={"تاریخ"}
                                        isGregorian={false}
                                        showTodayButton={true}
                                        timePicker={false}
                                        onChange={(e) => { this.state.fromDate = e }}
                                        value={this.getFormatedDateForDatePicker(this.state.fromDate)}
                                    />
                                    تا
                                    <DatePicker
                                        inputReadOnly={true}
                                        className="range-to-example text-center mr-r-5"
                                        style={{ border: "solid 1px #ccc" }}
                                        placeholder={"تاریخ"}
                                        isGregorian={false}
                                        showTodayButton={true}
                                        timePicker={false}
                                        onChange={(e) => { this.state.toDate = e }}
                                        value={this.getFormatedDateForDatePicker(this.state.toDate)}
                                    />
                                    <a className="hand mr-r-5" onClick={e => this.getData()}><i className="fa fa-search"></i></a>
                                </div>
                                <div className="col-sm-3 text-left">
                                    <button className="btn btn-no-frame btn-smoke hand" onClick={e => this.onPrint('تراز آزمایشی')} title="چاپ">
                                        <span className="fa fa-print"></span>
                                    </button>
                                    <button className="btn btn-no-frame btn-smoke hand" onClick={e => this.onPdf('تراز آزمایشی')} title="PDF">
                                        <span className="fa fa-file-pdf-o"></span>
                                    </button>
                                    <button className="btn btn-no-frame btn-smoke hand" onClick={e => this.onExcel('تراز آزمایشی')} title="اکسل">
                                        <span className="fa fa-file-excel-o"></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.renderAgGrid({
                    columnDefs: this.getColumns(),
                    pagination: false
                })}
            </div>
        );
	}
	render() {
		if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

		let contents = this.state.loading ? this.renderLoading() :
			[
				this.state.lockScreen === 1 && this.lockScreen(),
				<Header data={this.state.data} />,
				this.renderForm(),
				<Footer />
			];

		return contents;
	}
}